module.exports = __webpack_public_path__ + "img/wheat_nssx24.fb4d463f.jpg";